import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import commonApi from '../../api/common.api';
import { County, State } from '../../datatypes/Location';

export type LocationStateType = {
  stateLoading: boolean;
  countyLoading: boolean;
  states: State[];
  counties: County[];
  error: boolean;
};
const initialState: LocationStateType = {
  stateLoading: true,
  countyLoading: true,
  states: [],
  counties: [],
  error: false,
};

export const locationSlice = createSlice({
  name: 'location',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(fetchStates.pending, (state) => {
        state.stateLoading = true;
      })
      .addCase(fetchStates.fulfilled, (state, { payload }) => {
        state.states = payload;
        state.stateLoading = false;
      })
      .addCase(fetchStates.rejected, (state) => {
        state.stateLoading = false;
        state.error = true;
      })
      .addCase(fetchCounties.pending, (state) => {
        state.countyLoading = true;
      })
      .addCase(fetchCounties.fulfilled, (state, { payload }) => {
        state.counties = payload;
        state.countyLoading = false;
      })
      .addCase(fetchCounties.rejected, (state) => {
        state.countyLoading = false;
        state.error = true;
      });
  },
});

// Async API Hooks
/**
 * Fetch states from API and save in redux store
 */
export const fetchStates = createAsyncThunk(
  'location/fetchStates',
  async () => {
    const response = await commonApi().getStates();
    // The value we return becomes the `fulfilled` action payload
    return response;
  },
);
/**
 * Fetch Counties for the selected state from API and save in redux store
 */
export const fetchCounties = createAsyncThunk(
  'location/fetchCounties',
  async (state: string) => {
    const response = await commonApi().getCounties(state);
    // The value we return becomes the `fulfilled` action payload
    return response;
  },
);

export default locationSlice.reducer;
